import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePartnerAuth } from '../../context/PartnerAuthContext'
import { useOrder } from '../../context/OrderContext'

/**
 * PartnerBookPage – Point d'entrée du tunnel de réservation partenaire.
 *
 * Initialise le mode partenaire dans l'OrderContext puis redirige
 * vers /partner/book/service (premier step du tunnel).
 */
const PartnerBookPage: React.FC = () => {
  const navigate = useNavigate()
  const { partner, partnerProfile, loading, isPartner } = usePartnerAuth()
  const { setPartnerMode, resetOrder } = useOrder()

  useEffect(() => {
    if (loading) return

    if (!isPartner || !partner || !partnerProfile) {
      navigate('/partner/login')
      return
    }

    // Reset + activer le mode partenaire
    resetOrder()
    setPartnerMode({
      partnerId: partner.id,
      partnerAccountId: partnerProfile.id,
      partnerAddress: partner.address,
    })

    // Rediriger vers le premier step du tunnel partenaire
    navigate('/partner/book/service', { replace: true })
  }, [loading, isPartner, partner, partnerProfile]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
        <p>Chargement…</p>
      </div>
    )
  }

  return null
}

export default PartnerBookPage
